<template>
    <path d="M0 20L20 0l20 20-3.626 3.51L22.456 9.59V40h-4.912V9.59L3.51 23.51" fill-rule="evenodd"/>
</template>

<script>
export default {
    name: 'trendsArrowIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 40 40');
    }
};
</script>
